/* eslint-disable */

import Base from './base.js';

import { addCart } from '../services/cart';
import { getPrice } from '../services/price';
import { openPopUpBuy, configSelect } from '../services/popupBuy';
import { getOrderUrl } from '../services/order';

/**
 * 标准云产品基类
 */
export default class ProductBase extends Base {
  buyUrl;
  //获取购物车配置
  getCartConfig() {
    let commodityParams = Object.assign({}, this.config);
    // this.activityId && (commodityParams.businessInfo = {
    //   aliyun_shopcart_order_source: 'fromShopcart',
    //   order_activity_id: this.activityId
    // });

    // return {
    //   productCode: this.accessories.productCode,
    //   commodityParams: commodityParams,
    //   commodityDetail: {
    //     commodityCode: this.accessories.commodityCode,
    //     components: this.getComponents()
    //   }
    // };
    return {
      commodityParams: commodityParams,
      productCode: this.accessories.productCode
    };
  }

  //添加到购物车
  async addCart() {
    return this.execute(() => {
      return addCart(this.getCartConfig());
    });
  }

  //获取询价配置
  getPriceConfig(config) {
    let priceConfig = {
      commodityCode: this.accessories.commodityCode,
      param: Object.assign({}, config)
    };

    // 有活动时设置优惠
    // if (this.activityId) {
    //   priceConfig.param.businessInfo = {
    //     aliyun_shopcart_order_source: 'fromShopcart',
    //     order_activity_id: this.activityId
    //   };
    // }
    return priceConfig;
  }

  //获取价格
  getPrice(params) {
    let me = this;
    return new Promise((resolve) => {
      return me.getAllPrice(params).then((price) => {
        resolve(price.price)
      });
    });
  }

  //获取全部价格
  getAllPrice(params) {
    let me = this, config = me.config;
    //根据参数询价
    if (params) {
      let commodityValue = Object.assign({}, me.commodityValue, params);
      config = me.getConfig(commodityValue);
      me.formatPeroid(commodityValue, config);
    }
    return me.execute(() => {

      return new Promise((resolve) => {
        getPrice(me.getPriceConfig(config), me.hasSetValue, function (price) {
          let isServer = true;

          if (price == null || price.tradePrice == null) {
            price = me.commodityValue.price || {};
            isServer = false;
          }
          resolve({
            discountPrice: price.discountPrice, //优惠的价格
            originalPrice: price.originalPrice, //原价
            tradePrice: price.tradePrice, //折扣价
            price: price.tradePrice, //营销使用价
            currency: price.currency, //币种
            rules: price.rules || [], //优惠说明
            coupons: price.coupons || [],
            isServer: isServer, //是否服务端命中
            isInner: me.hasSetValue // 是否 匿名询价
          });
        });
      });
    });
  }

  //获取弹窗选配配置
  getPopupBuyConfig(popUpConfig) {
    return Object.assign({
      config: this.goods,
      goods: {
        goodsId: this.goods.goodsId,
        activityId: this.activityId,
        name: this.goods.name,
        accessories: Object.assign({}, this.accessories),
      }
    }, popUpConfig);
  }

  //打开选配框
  popUpBuy(popUpConfig) {
    return new Promise(resolve => {
      let me = this;
      return this.execute(() => {
        return openPopUpBuy(me.getPopupBuyConfig(popUpConfig), me, resolve);
      });
    });
  }
  // 弹窗选配
  popUpConfig(popUpConfig) {
    return new Promise(resolve => {
      let me = this;
      return this.execute(() => {
        return configSelect(me.getPopupBuyConfig(popUpConfig), me, resolve);
      });
    });
  }
  //获取下单配置
  getOrderConfig() {
    return this.config;
  }

  //获取订单url
  getOrderUrl() {
    return this.execute(() => {
      return this.orderUrl ? getOrderUrl(this.orderUrl, this.getOrderConfig()) : '';
    });
  }
  // 获取配置信息
  getValueText() {
    const text = [];
    const value = this.getValue();
    const options = this.getOptions();
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        const element = value[key];
        const target = options.find(item => item.key == key);
        if (target) {
          // 找到了，进行翻译
          const temp = {
            key: key,
            label: target.label,
            value: null
          }
          target.value.some(item => {
            if (typeof item !== 'string') {
              // 枚举值
              if (item.value) {
                if (item.value.indexOf(element) >= 0) {
                  temp.value = item.text;
                  return true;
                }
              } else {
                console.warn(item, element);
                // 区间 TODO
                if (item.unit) {
                  if (typeof element === 'object') {
                    // temp.value = `${element} ${item.unit}`;
                  } else {
                    temp.value = `${element} ${item.unit}`;
                  }
                } else {
                  temp.value = `${element}`;
                }
                return true;
              }
            } else {
              // 字符串 TODO（针对vm_os要单独支持）
              item.indexOf(element) >= 0
              temp.value = element;
              return true;
            }
          });
          if (temp.value != null) {
            text.push(temp);
          }
        } else {
          // 没找到 不翻译
        }
      }
    }
    return text;
  }
  // //获取支付配置
  // getPayConfig(payConfig) {
  //   let config = this.getPriceConfig(this.config);
  //   config.orderParams && (config.orderParams.paidCallBack = config.returnUrl); 
  //   return config;
  // }

  // //获取支付页地址
  // getPayUrl(payConfig) {
  //   let me = this;
  //   return me.execute(() => {
  //     return new Promise(resolve => {
  //       getPayUrl(me.getPayConfig(payConfig), resolve);
  //     }) 
  //   });
  // }
}


// WEBPACK FOOTER //
// ./lib/services/product/productBase.js